import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';

import { Block, Paragraph } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { Breadcrumbs } from '../../../components';
import { DEFAULT_LANGUAGE } from '../../../config/constants';
import { NodeOverviewPage as Type } from '../../../types/uncinc_profile/nodes';

export interface NodeOverviewPageProps {
  entity: ImmutableEntity<Type>;
  className?: string;
}

const NodeOverviewPage: React.FC<NodeOverviewPageProps> = ({ entity, className }) => {
  const classes = classNames(className, 'NodeOverviewPage');
  const node = entity.toJS();

  const title = node.title[0].value;
  const body = node.body[0]?.processed;
  const paragraphs = node.field_paragraphs;

  const contactFormBlockEntity = entity.getIn(['field_contact_form_block', 0, 'entity'], Immutable.Map());

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <Container>
        <div className="row">
          <div className="col-12">
            <Breadcrumbs />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-7">
            <h1 itemProp="name" className="mb-0">
              {title}
            </h1>

            {body && (
              <WysiwygField
                className="body--large mt-5 mt-lg-6"
                property="schema:text"
                html={body}
              />
            )}
          </div>
        </div>

        {paragraphs.length > 0 && (
          <div className={`content-section ${!body ? 'mt-8 mt-lg-12' : ''}`}>
            <div className="NodeOverviewPage__paragraphs">
              {paragraphs.map((paragraph) => {
                const id = paragraph.target_id;
                const language = paragraph.entity?.langcode[0].value || DEFAULT_LANGUAGE;

                return (
                  <Paragraph
                    key={`paragraph:${id}:${language}`}
                    id={id}
                    entity={Immutable.fromJS(paragraph.entity)}
                  />
                );
              })}
            </div>
          </div>
        )}

        {contactFormBlockEntity && (
          <Block entity={contactFormBlockEntity} />
        )}
      </Container>
    </article>
  );
};

export default NodeOverviewPage;
